import React from 'react';
import './Toggler.sass';

const Toggler = (props) => (
	<button type="button" onClick={props.onToggleClick} className={`uikit-button-toggler ${props.className}`}>
		<span />
	</button>
);

export default Toggler;
